import React from 'react'

const Separator = ({ style = 'dashed', className }) => {
  return <hr className={`${className} border-${style} border-1 border-white`} />
}
export default Separator
